import { Component, OnInit } from '@angular/core';

@Component({
  template: require('./abastecimento-bens.component.html')
})
export class AbastecimentoBensComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/abastecimento-bens.component.ts
 **/